import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";

import * as sharedDiscussionStyles from "../shared-styles.ts";

type Props = {
    selected: boolean;
};

// TODO(kevinb): replace with radio from wonder-blocks-form when ready
export default class FakeRadio extends React.Component<Props> {
    static defaultProps: {
        selected: boolean;
    } = {
        selected: false,
    };

    render(): React.ReactNode {
        const {selected} = this.props;

        return (
            <View
                aria-hidden="true"
                style={[
                    styles.fakeRadioButton,
                    selected && styles.selectedFakeRadioButton,
                ]}
            />
        );
    }
}

const fakeRadioButtonSize = 16;

const styles = StyleSheet.create({
    fakeRadioButton: {
        flexShrink: 0,
        flexGrow: 0,
        borderRadius: "50%",
        width: fakeRadioButtonSize,
        height: fakeRadioButtonSize,
        border: sharedDiscussionStyles.border,
        marginRight: 8,
        boxSizing: "border-box",
    },

    selectedFakeRadioButton: {
        border: `4px solid ${color.blue}`,
    },
});
